import { render, staticRenderFns } from "./ServiceTakerAllocationListPage.vue?vue&type=template&id=615a8ae4&"
import script from "./ServiceTakerAllocationListPage.vue?vue&type=script&lang=js&"
export * from "./ServiceTakerAllocationListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports